import { __decorate } from "tslib";
import { Component, Vue, Watch, Prop, Model } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import axios from 'axios';
export class MalSearchOptionData {
    constructor(op) {
        const that = this;
        if (op) {
            Object.keys(op).forEach((k) => {
                that[k] = op[k];
            });
        }
    }
}
let MalSearchOption = class MalSearchOption extends Vue {
    constructor() {
        super();
        this.menuDatePicker = {
            visible: false,
            date: '',
            events: [],
            loading: false,
        };
        this.menuDateRange = {
            visible: false,
            dateRange: [],
            events: [],
        };
        this.datesLoading = false;
        this.currentDates = [];
        this.dateRangeMonthCheckTimer = null;
        this.lastCheckedMonthForRange = '';
        this.registerCategoryList = ['人工', '在线', '离线'];
        this.listHospital = [];
        const that = this;
    }
    // 计算属性：合并 props 中的 dates 和动态加载的 currentDates
    get mergedDates() {
        const that = this;
        // 合并 props.dates 和 currentDates，去重
        const allDates = [
            ...(that.dates || []),
            ...(that.currentDates || [])
        ];
        // 确保日期格式为 yyyy-MM-dd，并去重
        return [...new Set(allDates)]
            .filter((v) => v && v.trim())
            .map((v) => {
            // 如果日期包含时间部分，只取日期部分
            const dateStr = String(v).trim();
            if (dateStr.length > 10) {
                return dateStr.substring(0, 10);
            }
            return dateStr;
        });
    }
    // events 函数：Vuetify 2.x 的 events 可以是函数形式，返回布尔值表示该日期是否有事件
    get eventsFunction() {
        const that = this;
        // 使用 Set 提高查找性能，并确保日期格式一致
        const datesSet = new Set(that.mergedDates.map((d) => {
            const dateStr = String(d).trim();
            return dateStr.length > 10 ? dateStr.substring(0, 10) : dateStr;
        }));
        return (date) => {
            if (!date)
                return false;
            // date 格式为 yyyy-MM-dd
            const dateStr = String(date).trim();
            const normalizedDate = dateStr.length > 10 ? dateStr.substring(0, 10) : dateStr;
            return datesSet.has(normalizedDate);
        };
    }
    changed(v) {
        const that = this;
        that.$emit('input', v);
    }
    onHospitalChange() {
        const that = this;
        // 当医院改变时，清空设备选择
        that.option.device = null;
        that.changed(that.option);
    }
    get filteredDevices() {
        const that = this;
        if (!that.option.hospital) {
            return that.devices.filter((v) => that.option.deviceType ? (v.type === that.option.deviceType) : v);
        }
        // 根据选择的医院过滤设备
        const hospitalDevices = that.option.hospital.devices || [];
        return that.devices.filter((v) => {
            const isInHospital = hospitalDevices.find((h) => h.deviceId === v.deviceId);
            const matchesType = that.option.deviceType ? (v.type === that.option.deviceType) : true;
            return isInHospital && matchesType;
        });
    }
    deviceFilter(item, queryText, itemText) {
        const text = String(queryText).toLowerCase().trim();
        if (!text)
            return true;
        const name = String(item.name || '').toLowerCase();
        const deviceNo = String(item.deviceNo || '').toLowerCase();
        return name.includes(text) || deviceNo.includes(text);
    }
    async getHospitalList() {
        const that = this;
        try {
            const ret = await axios.get('/api/hospital', {
                params: {
                    simple: false,
                    short: true
                }
            });
            that.listHospital = (ret && ret.data && ret.data.result || []).sort((a, b) => b.deviceCount - a.deviceCount);
            return ret;
        }
        catch (e) {
            console.error('获取医院列表失败:', e);
            throw e;
        }
    }
    selectDate(date) {
        const that = this;
        if (date && Array.isArray(date)) {
            if (date.length >= 2) {
                // 选择了完整的日期范围，关闭选择器
                that.menuDateRange.visible = false;
                // 加载日期范围中所有月份的 dates（如果跨月）
                that.loadDatesForDateRange(date);
            }
            else if (date.length === 1) {
                // 当选择第一个日期时，加载该日期所在月份的 dates
                const dateStr = date[0];
                if (dateStr) {
                    const dateObj = new Date(dateStr);
                    if (!isNaN(dateObj.getTime())) {
                        that.loadDatesForMonth(dateObj);
                    }
                }
            }
        }
    }
    /**
     * 为日期范围加载所有相关月份的 dates
     * @param dateRange - 日期范围数组 [startDate, endDate]
     */
    async loadDatesForDateRange(dateRange) {
        const that = this;
        if (!dateRange || dateRange.length < 2)
            return;
        const startDate = new Date(dateRange[0]);
        const endDate = new Date(dateRange[1]);
        if (isNaN(startDate.getTime()) || isNaN(endDate.getTime()))
            return;
        // 获取日期范围内的所有月份
        const months = new Set();
        const currentDate = new Date(startDate);
        while (currentDate <= endDate) {
            const monthStr = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}`;
            months.add(monthStr);
            currentDate.setMonth(currentDate.getMonth() + 1);
        }
        // 加载所有月份的 dates 并合并
        that.datesLoading = true;
        try {
            const allDates = [];
            for (const month of months) {
                try {
                    const res = await axios.get('/api/malfunctions/categories', {
                        params: {
                            type: 'date',
                            month: month
                        }
                    });
                    const result = res.data && res.data.result;
                    if (result && result.dates) {
                        const dates = String(result.dates)
                            .split(',')
                            .filter((v) => v && v.trim())
                            .map((v) => v.trim());
                        allDates.push(...dates);
                    }
                }
                catch (error) {
                    console.error(`加载 ${month} 月份的日期列表失败:`, error);
                }
            }
            // 去重并排序
            that.currentDates = [...new Set(allDates)].sort();
        }
        catch (error) {
            console.error('加载日期范围列表失败:', error);
            that.currentDates = [];
        }
        finally {
            that.datesLoading = false;
        }
    }
    /**
     * 当日期范围选择器打开时触发
     */
    async onDateRangePickerOpen(visible) {
        const that = this;
        if (visible) {
            // 当日期范围选择器打开时，加载当前显示月份的 dates
            // 如果有已选择的日期范围，使用第一个日期；否则使用当前日期
            let dateStr = null;
            if (that.option.dateRange && Array.isArray(that.option.dateRange) && that.option.dateRange.length > 0) {
                dateStr = that.option.dateRange[0];
            }
            if (!dateStr) {
                dateStr = new Date().toISOString().split('T')[0];
            }
            const date = new Date(dateStr);
            if (!isNaN(date.getTime())) {
                await that.loadDatesForMonth(date);
                that.lastCheckedMonthForRange = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
                // 启动定时器，定期检查月份是否变化（用于检测用户点击月份导航按钮）
                that.startDateRangeMonthCheckTimer();
            }
            // 强制更新视图，确保 events 正确显示
            that.$nextTick(() => {
                that.$forceUpdate();
            });
        }
        else {
            // 关闭时清除定时器
            that.stopDateRangeMonthCheckTimer();
        }
    }
    /**
     * 启动日期范围选择器的月份检查定时器
     */
    startDateRangeMonthCheckTimer() {
        const that = this;
        that.stopDateRangeMonthCheckTimer(); // 先清除之前的定时器
        that.dateRangeMonthCheckTimer = setInterval(async () => {
            if (!that.menuDateRange.visible) {
                that.stopDateRangeMonthCheckTimer();
                return;
            }
            // 尝试从日期范围选择器获取当前显示的月份
            // 通过检查已选择的日期或当前日期来推断
            let dateStr = null;
            if (that.option.dateRange && Array.isArray(that.option.dateRange) && that.option.dateRange.length > 0) {
                dateStr = that.option.dateRange[0];
            }
            if (!dateStr) {
                dateStr = new Date().toISOString().split('T')[0];
            }
            const date = new Date(dateStr);
            if (!isNaN(date.getTime())) {
                const currentMonth = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
                if (currentMonth !== that.lastCheckedMonthForRange) {
                    that.lastCheckedMonthForRange = currentMonth;
                    await that.loadDatesForMonth(date);
                    // 强制更新视图，确保 events 正确显示
                    that.$nextTick(() => {
                        that.$forceUpdate();
                    });
                }
            }
        }, 500); // 每500ms检查一次
    }
    /**
     * 停止日期范围选择器的月份检查定时器
     */
    stopDateRangeMonthCheckTimer() {
        const that = this;
        if (that.dateRangeMonthCheckTimer) {
            clearInterval(that.dateRangeMonthCheckTimer);
            that.dateRangeMonthCheckTimer = null;
        }
    }
    async created() {
        /** 去加载设备类型列表【禅道任务392】 */
        const that = this;
        await axios.get('/api/device/type')
            .then((res) => {
            const ret = res.data.result.map((v) => v.name);
            if (ret.length) {
                that.deviceTypeList = ret;
            }
        })
            .catch((err) => { });
        // 加载医院列表
        await that.getHospitalList();
        // 初始化时，如果有 props.dates，同步到 currentDates
        if (that.dates && Array.isArray(that.dates) && that.dates.length > 0) {
            // 确保日期格式为 yyyy-MM-dd
            const formattedDates = that.dates.map((v) => {
                const dateStr = String(v).trim();
                return dateStr.length > 10 ? dateStr.substring(0, 10) : dateStr;
            });
            that.currentDates = [...formattedDates];
        }
    }
    // 监听 props.dates 的变化，同步到 currentDates
    onDatesChange(newDates) {
        const that = this;
        if (newDates && Array.isArray(newDates) && newDates.length > 0) {
            // 确保日期格式为 yyyy-MM-dd，并合并到 currentDates
            const formattedDates = newDates.map((v) => {
                const dateStr = String(v).trim();
                if (dateStr.length > 10) {
                    return dateStr.substring(0, 10);
                }
                return dateStr;
            });
            // 合并现有的 currentDates 和新的 dates，去重
            const allDates = [...(that.currentDates || []), ...formattedDates];
            that.currentDates = [...new Set(allDates)].filter((v) => v && v.trim());
        }
    }
    /**
     * 当日期选择器打开时触发
     */
    async onDatePickerOpen(visible) {
        const that = this;
        if (visible) {
            // 当日期选择器打开时，加载当前显示月份的 dates
            // 如果有已选择的日期，使用该日期；否则使用当前日期
            const dateStr = that.option.date || new Date().toISOString().split('T')[0];
            const date = new Date(dateStr);
            if (!isNaN(date.getTime())) {
                await that.loadDatesForMonth(date);
            }
            // 强制更新视图，确保 events 正确显示
            that.$nextTick(() => {
                that.$forceUpdate();
            });
        }
    }
    /**
     * 当日期选择器输入日期时触发
     * @param dateStr - 日期字符串，格式为 yyyy-MM-dd
     */
    async onDateInput(dateStr) {
        const that = this;
        that.menuDatePicker.visible = false;
        // 如果选择了日期，加载该日期所在月份的 dates
        if (dateStr) {
            const date = new Date(dateStr);
            if (!isNaN(date.getTime())) {
                await that.loadDatesForMonth(date);
            }
        }
    }
    /**
     * 当日期选择器的显示月份改变时触发（点击左右箭头切换月份）
     * @param dateStr - 日期字符串，格式为 yyyy-MM-dd，表示当前显示的月份中的某个日期
     */
    async onPickerDateChange(dateStr) {
        const that = this;
        if (!dateStr)
            return;
        // 解析日期，获取年月
        const date = new Date(dateStr);
        if (isNaN(date.getTime()))
            return;
        // 加载该月份的 dates
        await that.loadDatesForMonth(date);
        // 强制更新 events（触发计算属性重新计算）
        that.$nextTick(() => {
            that.$forceUpdate();
        });
    }
    /**
     * 加载指定月份的 dates 列表
     * @param date - Date 对象，用于确定要加载的月份
     */
    async loadDatesForMonth(date) {
        const that = this;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const monthStr = `${year}-${month}`;
        that.datesLoading = true;
        try {
            const res = await axios.get('/api/malfunctions/categories', {
                params: {
                    type: 'date',
                    month: monthStr
                }
            });
            const result = res.data && res.data.result;
            if (result && result.dates) {
                // 将 dates 字符串（逗号分隔）转换为数组
                const newDates = String(result.dates)
                    .split(',')
                    .filter((v) => v && v.trim())
                    .map((v) => {
                    const dateStr = v.trim();
                    // 确保格式为 yyyy-MM-dd
                    return dateStr.length > 10 ? dateStr.substring(0, 10) : dateStr;
                });
                // 合并到现有的 currentDates，去重
                const allDates = [...(that.currentDates || []), ...newDates];
                that.currentDates = [...new Set(allDates)].filter((v) => v && v.trim());
            }
        }
        catch (error) {
            console.error('加载日期列表失败:', error);
            that.currentDates = [];
        }
        finally {
            that.datesLoading = false;
        }
    }
    beforeDestroy() {
        const that = this;
        that.stopDateRangeMonthCheckTimer();
    }
};
__decorate([
    Getter
], MalSearchOption.prototype, "deviceTypeList", void 0);
__decorate([
    Prop({ default: 'common' })
], MalSearchOption.prototype, "mode", void 0);
__decorate([
    Prop()
], MalSearchOption.prototype, "devices", void 0);
__decorate([
    Prop()
], MalSearchOption.prototype, "statuses", void 0);
__decorate([
    Prop()
], MalSearchOption.prototype, "statusLists", void 0);
__decorate([
    Prop()
], MalSearchOption.prototype, "categories", void 0);
__decorate([
    Prop()
], MalSearchOption.prototype, "userInfoList", void 0);
__decorate([
    Prop()
], MalSearchOption.prototype, "modules", void 0);
__decorate([
    Prop()
], MalSearchOption.prototype, "dates", void 0);
__decorate([
    Model('value')
], MalSearchOption.prototype, "option", void 0);
__decorate([
    Watch('dates', { immediate: true, deep: true })
], MalSearchOption.prototype, "onDatesChange", null);
MalSearchOption = __decorate([
    Component({
        name: 'MalSearchOption',
    })
], MalSearchOption);
export default MalSearchOption;
;
